import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlDeviceType } from "~/__generated__";

const LOGIN = gql(`
mutation UserLogin($email: String!, $password: String!, $deviceType: GqlDeviceType!) {
    userLogin(email: $email, password: $password, deviceType: $deviceType) {
        jwt
    }
}
`);

export default function useLoginQuery() {
    const [login, { loading, error }] = useMutation(LOGIN);

    const onLogin = useCallback(
        async (email: string, password: string) => {
            return await login({
                variables: {
                    email,
                    password,
                    deviceType: GqlDeviceType.Browser,
                },
            });
        },
        [login],
    );

    return {
        loading,
        error,
        login: onLogin,
    };
}
